import { readUnhandledEnumCase } from 'rpc-client-utils';
import { CAPACITY_CATEGORIES, CAPACITY_CONFIG_TYPES } from '../constants';
import Raven from 'raven-js';
export const defaultLimitToInfinity = ({
  capacityLimit,
  capacityLoad
}) => ({
  capacityLimit: capacityLimit !== null && capacityLimit !== void 0 ? capacityLimit : Infinity,
  capacityLoad
});
export const isCapacityFull = capacity => {
  var _capacity$capacityLim;
  return !!capacity && capacity.capacityLoad >= ((_capacity$capacityLim = capacity.capacityLimit) !== null && _capacity$capacityLim !== void 0 ? _capacity$capacityLim : Infinity);
};
export const hasLimit = capacity => {
  return !!capacity && typeof capacity.capacityLimit === 'number';
};

// validate configuration type enum, default to TOTAL
export const getConfigurationType = configurationType => {
  const checkedString = configurationType && readUnhandledEnumCase(configurationType);
  switch (checkedString) {
    case CAPACITY_CONFIG_TYPES.TOTAL:
    case CAPACITY_CONFIG_TYPES.BY_CAPACITY_CATEGORY:
      return checkedString;
    default:
      return CAPACITY_CONFIG_TYPES.TOTAL;
  }
};

// validate category enums
export const getCapacityByCategory = capacityByCategory => ({
  ASYNC_COMMUNICATION: capacityByCategory[CAPACITY_CATEGORIES.ASYNC_COMMUNICATION],
  CALLING: capacityByCategory[CAPACITY_CATEGORIES.CALLING],
  REAL_TIME_MESSAGING: capacityByCategory[CAPACITY_CATEGORIES.REAL_TIME_MESSAGING]
});
export const getUserCapacityData = userCapacityData => {
  const type = getConfigurationType(userCapacityData.capacityConfigurationType);
  switch (type) {
    case 'BY_CAPACITY_CATEGORY':
      return {
        type,
        capacity: getCapacityByCategory(userCapacityData.categoryUserCapacityData)
      };
    case 'TOTAL':
      return {
        type,
        capacity: userCapacityData.totalTicketUserCapacityData
      };
    default:
      return null;
  }
};
const formatCategoryCapacity = message => {
  const limits = message.capacityLimitsByCategory || {};
  const loads = message.capacityLoadsByCategory;
  const categories = Object.values(CAPACITY_CATEGORIES);
  return categories.reduce((acc, category) => {
    acc[category] = {
      capacityLimit: limits[category],
      capacityLoad: loads[category]
    };
    return acc;
  }, {});
};

/**
 * Converts a realtime capacity update message to equivalent chirp response
 * @param message - The realtime message to convert
 * @returns The converted response or null if there is an error parsing the message.
 */
export const realtimeMessageToResponse = message => {
  try {
    var _message$capacityLimi;
    return {
      capacityConfigurationType: message.configurationType,
      categoryUserCapacityData: formatCategoryCapacity(message),
      totalTicketUserCapacityData: {
        capacityLimit: (_message$capacityLimi = message.capacityLimit) !== null && _message$capacityLimi !== void 0 ? _message$capacityLimi : undefined,
        capacityLoad: message.capacityLoad
      }
    };
  } catch (e) {
    Raven.captureException(e);
    return null;
  }
};

// TODO: refactor, add assignee capacity utils
export const isAgentOnCall = agent => {
  var _agent$userCapacityDa;
  const callLoad = (_agent$userCapacityDa = agent.userCapacityDataResult) === null || _agent$userCapacityDa === void 0 || (_agent$userCapacityDa = _agent$userCapacityDa.categoryCapacityData) === null || _agent$userCapacityDa === void 0 || (_agent$userCapacityDa = _agent$userCapacityDa.CALLING) === null || _agent$userCapacityDa === void 0 ? void 0 : _agent$userCapacityDa.capacityLoad;
  return !!callLoad && callLoad > 0;
};